import { createSlice } from "@reduxjs/toolkit"

const initialSurgicalState = { 
    activeDrawer: null,
    activeTab: 1,
}

const surgicalSlice = createSlice({
    name: 'surgical',
    initialState: initialSurgicalState,
    reducers: {
        setActiveDrawer(state, data) {
            state.activeDrawer = data.payload
        },
        setActiveTab(state, data) {
            state.activeTab = data.payload
        }
    }
})

export const surgicalActions = surgicalSlice.actions

export default surgicalSlice.reducer